<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M2.54,784.24l2.67,0.21l0.21,2.67l1.74,2.04l-1.74,2.04l-0.21,2.67l-2.67,0.21l-2.04,1.74l-2.04-1.74l-2.67-0.21l-0.21-2.67
	l-1.74-2.04l1.74-2.04l0.21-2.67l2.67-0.21l2.04-1.74L2.54,784.24z M0.5,785c-2.29,0-4.17,1.88-4.17,4.17
	c0,2.29,1.87,4.17,4.17,4.17s4.17-1.87,4.17-4.17C4.67,786.88,2.79,785,0.5,785L0.5,785z M3,789.17c0,1.39-1.11,2.5-2.5,2.5
	s-2.5-1.11-2.5-2.5s1.11-2.5,2.5-2.5S3,787.78,3,789.17z M-2.05,795.31l2.55,2.17l2.55-2.17l0.79-0.06v7.25L0.5,800l-3.33,2.5v-7.25
	L-2.05,795.31z"/>
</svg>

</template>